import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { CombinatoriaI } from "interfaces/Combinatoria";
import { Dropdown } from "react-bootstrap";
import { deleteCombinatoria } from "services/combinatoria";

interface Props {
  elemento: CombinatoriaI;
  onClickEdit: (elemento: CombinatoriaI) => void;
  refreshTable: () => void;
}

export const CombinatoriaRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      const result = await deleteCombinatoria(id);
      showSuccessToast("¡La combinatoria fue eliminada con éxito!");
      refreshTable();
    } catch (error: any) {
      showErrorToast(error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {/* <Dropdown.Item onClick={() => onClickVerDocumento(elemento.documentacionAdjunta.id)}>Ver documento</Dropdown.Item> */}

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar combinatoria"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la combinatoria {elemento.id} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
